const BASE_URL_DEV = 'http://localhost:5000/'
const BASE_URL_PRO = '/'
var BASE_URL = ''

if (process.env.NODE_ENV === 'development') {
  BASE_URL = BASE_URL_DEV
} else {
  BASE_URL = BASE_URL_PRO
}
export const baseURLAPI = BASE_URL + 'api/'
export const baseURL = BASE_URL

export const TOKEN_KEY = 'token'
